/**
 * Helper to handle cookies in navigator with JS
 */

/**
 * Get Cookie from name
 *
 * @param {?string} cookieName The name of the cookie
 */
export function getCookie(cookieName) {
  // Init searched cookie and list of cookies
  const name = `${cookieName}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieList = decodedCookie.split(';');

  // Find specified cookie
  const cookieFound = cookieList
    .map(cookie => {
      return cookie.trim();
    })
    .find(cookieTrimmed => {
      // Return cookie value
      return cookieTrimmed.indexOf(name) === 0;
    });

  // Get value from cookie name
  const cookieValue = cookieFound ? cookieFound.slice(name.length, cookieFound.length) : undefined;

  return cookieValue?.length ? cookieValue : undefined;
}

/**
 * Set Cookie in document
 *
 * Also used to remove with expireDays = -1
 *
 * @param {string} cookieName Name of the cookie
 * @param {string} cookieValue Value of the cookie
 * @param {number} expireDays Days to expire
 * @param {string} devHost hostname to use in dev mode
 *
 */
export function setCookie(cookieName, cookieValue, expireDays) {
  // Set expire days
  const d = new Date();
  d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
  const expires = d.toUTCString();

  // Get domain for cookie
  const domainArray = window.location.host.split('.');
  //  Remove first part of domain
  domainArray.shift();

  // Set cookie
  document.cookie = `${cookieName}=${cookieValue};expires=${expires};path=/;domain=${domainArray.join('.')};`;
}
/**
 * Set Cookie in document
 *
 * Also used to remove with expireDays = -1
 *
 * @param {string} cookies Name of the cookie
 * @param {string} domain Value of the cookie
 *
 */
export function clearCookies(cookies, domain) {
  cookies.forEach(cookie => {
    document.cookie = `${cookie}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain};`;
  });
}
